import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { TranslateService } from '../../../../services/translate.service';
import { SegProfile } from '../../../../services/template-mappers/entities/risk-register-seg-group.model';
import { SEG_STYLES } from '../seg-profile/seg-profile-presentation.service';

@Component({
    standalone: true,
    selector: 'app-seg-job-roles-widget',
    imports: [],
    templateUrl: './seg-job-roles-widget.component.html',
    styleUrl: './seg-job-roles-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SegJobRolesWidgetComponent implements OnInit {
    @Input() profiles: SegProfile[] | null = null;

    readonly styles = SEG_STYLES;
    labels = { heading: '', role: '', samples: '', noData: '' };

    constructor(private translateService: TranslateService) { }

    ngOnInit(): void {
        const t = (key: string) => this.translateService.getDynamicTranslation(key);
        this.labels = {
            heading: t('Job Roles'),
            role: t('Job Role'),
            samples: t('Sample Count'),
            noData: t('No Data Available')
        };
    }

    public trackByIndex = trackByIndex;
}
